import { inject, Injectable } from '@angular/core';
import { AutopropBackend } from 'app/shared/backend/autoprop-backend';
import { Product } from './subscriptions.model';


@Injectable({
    providedIn: 'root',
})
export class PaymentService {

    private backend = inject(AutopropBackend);

    processPayment(
        intentId: string,
        customerId: string | null,
        plan: number | string,
        idempotencyKey: string,
        billingPeriod: null | string = null,
        couponId: null | string = null
    ) {
        return this.backend.post('/api/user/payment', { intentId, customerId, plan, billingPeriod, couponId, idempotencyKey });
    }

    processPaymentProduct(intentId: string, customerId: string | null, product: Product, idempotencyKey: string, couponId: null | string = null,  metadata: Record<string, string> | null = null) {
        return this.backend.post('/api/user/product_payment', { intentId, customerId, product, couponId, idempotencyKey, purchaseMetadata: metadata });
    }

    subscribeBundle(planId: string, billingPeriod: string, couponId: null | string = null) {
        return this.backend.post('/api/user/subscribe', { planId, billingPeriod, couponId });
    }

    buyProduct(product: Product, idempotencyKey: string, couponId: null | string = null, metadata: Record<string, string> | null = null) {
        return this.backend.post('/api/user/buy_product', { product, couponId, idempotencyKey, purchaseMetadata: metadata });
    }

    createSetupIntent(customerId: string | null, idempotencyKey: string) {
        return this.backend.post('/api/user/create-setup-intent', { customerId, idempotencyKey });
    }

    createCustomer(idempotencyKey: string) {
        return this.backend.post('/api/user/create-stripe-customer', { idempotencyKey });
    }
}
